import { AfterContentInit, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { EStrategyStatus } from 'src/app/domain/enum/strategy-status';
import { Strategy } from 'src/app/domain/strategy';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { SimpleListModel } from 'src/app/model/simple-list-model';
import { DocumentService } from 'src/app/services/document.service';
import { StrategyService } from 'src/app/services/strategy.service';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { ExportBoxDialog } from 'src/app/tools/ui/export-box/export-box';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { BaseComponent } from '../base/base.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-strat-list',
    templateUrl: './strat-list.component.html',
    styleUrls: ['./strat-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StratListComponent extends BaseComponent implements OnInit, AfterContentInit {
    EStrategyStatus = EStrategyStatus;
    HorsStrategy: boolean = false;
    AvailableStrategyList: Strategy[] = [];
    StrategyList: Strategy[] = [];
    SearchText: string = '';
    SelectedStatus: EStrategyStatus;
    StrategyStatusList: SimpleListModel[] =
        _.uniqBy(Object.values(EStrategyStatus)
            .filter(x => !isNaN(Number(x)))
            .map(x => {
                const n = new SimpleListModel();
                n.idx = x as number;
                n.s = StringConverter.getStrategyStatusName(x as EStrategyStatus);
                return n;
            }), x => x.s);
    OnlyFavorites: boolean;

    constructor(
        protected coreData: CoreData,
        private router: Router,
        private dialog: MatDialog,
        private strategyService: StrategyService,
        private documentService: DocumentService) {
        super(coreData);
    }

    ngOnInit(): void {
    }

    ngAfterContentInit(): void {
        this.strategyService.getStrategyList().subscribe(x => {
            this.AvailableStrategyList = _.orderBy(x, [(o) => { return o.Portfolio.StrategyRequestDate || '' }], 'desc');
            this.StrategyList = this.AvailableStrategyList;
            if (this.coreData.StrategyStatusFilter) {
                this.SelectedStatus = this.coreData.StrategyStatusFilter;
            } else {
                this.SelectedStatus = EStrategyStatus.WorkInProgress;
            }
            this.search();
        });
        this.OnlyFavorites = false;
    }

    getStrategyStatusName(status: EStrategyStatus) {
        return StringConverter.getStrategyStatusName(status);
    }

    toggleFavorite(strategy: Strategy) {
        this.strategyService.toggleFavorite(strategy).subscribe(x => {
            if (typeof (x) === 'boolean') {
                strategy.IsFavorite = x;
            }
        })
    }

    getColorByInterventionStatus(status) {  // Strategy type or status maybe
        switch (status) {
            case EStrategyStatus.New:
                // return ColorService.getNewColor(Object.values(EStrategyStatus).filter(x => !isNaN(Number(x))).length);
                // return '#758065';
                return '#96aff2';
            // return '#0072bc';
            // return '#D2E3ED';
            case EStrategyStatus.WorkMeasurementMPCA:
                // return ColorService.getNewColor(Object.values(EStrategyStatus).filter(x => !isNaN(Number(x))).length);
                // return '#758065';
                return '#96aff2';
            // return '#0072bc';
            // return '#FFDD00';
            case EStrategyStatus.ZoneProcess:
                // return ColorService.getNewColor(Object.values(EStrategyStatus).filter(x => !isNaN(Number(x))).length);
                // return '#758065';
                return '#96aff2';
            // return '#0072bc';
            // return '#FFDD00';
            case EStrategyStatus.Ordered:
                // return ColorService.getNewColor(Object.values(EStrategyStatus).filter(x => !isNaN(Number(x))).length);
                // return '#3fb096';
                return '#0072bc';
            // return '#FFDD00';
            case EStrategyStatus.WorkInProgress:
                return '#bca0bc';
            // return '#0072bc';
            case EStrategyStatus.Proposal:
                // return ColorService.getNewColor(Object.values(EStrategyStatus).filter(x => !isNaN(Number(x))).length);
                // return '#96aff2';
                return '#3fb096';
            // return '#AAC2A0';
            case EStrategyStatus.FinalReportTBD:
                // return ColorService.getNewColor(Object.values(EStrategyStatus).filter(x => !isNaN(Number(x))).length);
                return '#D5A021';
            // return '#Ab3f97';
            case EStrategyStatus.FinalReport:
                return '#e0675e';
            // return '#4a3276';
            default:
                return 'pink';
        }
    }

    saveLastSelectedStatus() {
        this.coreData.StrategyStatusFilter = this.SelectedStatus;
    }

    search() {
        if (this.SelectedStatus && this.SelectedStatus === this.ALL) { // Get all
            this.StrategyList = this.AvailableStrategyList.filter(x => x.Portfolio.SamplingPoint.Name.toLocaleLowerCase().includes(this.SearchText.toLocaleLowerCase()) && x.ContexteHorsStrategie === this.HorsStrategy);
        } else if (this.SelectedStatus &&
            (this.SelectedStatus === EStrategyStatus.WorkMeasurementMPCA ||
                this.SelectedStatus === EStrategyStatus.ZoneProcess ||
                this.SelectedStatus === EStrategyStatus.New)) {

            this.StrategyList = this.AvailableStrategyList.filter(x => x.Portfolio.SamplingPoint.Name.toLocaleLowerCase().includes(this.SearchText.toLocaleLowerCase())
                && x.ContexteHorsStrategie === this.HorsStrategy
                && (x.Status === EStrategyStatus.New || x.Status === EStrategyStatus.WorkMeasurementMPCA || x.Status === EStrategyStatus.ZoneProcess));
        } else if (this.SelectedStatus &&
            (this.SelectedStatus === EStrategyStatus.WorkInProgress ||
                this.SelectedStatus === EStrategyStatus.FinalReportTBD)) {
            this.StrategyList = this.AvailableStrategyList.filter(x => x.Portfolio.SamplingPoint.Name.toLocaleLowerCase().includes(this.SearchText.toLocaleLowerCase())
                && x.ContexteHorsStrategie === this.HorsStrategy
                && (x.Status === EStrategyStatus.WorkInProgress || x.Status === EStrategyStatus.FinalReportTBD));
        }
        else
            this.StrategyList = this.AvailableStrategyList.filter(x => x.Portfolio.SamplingPoint.Name.toLocaleLowerCase().includes(this.SearchText.toLocaleLowerCase())
                && x.ContexteHorsStrategie === this.HorsStrategy
                && x.Status === this.SelectedStatus);
        this.StrategyList = _.orderBy(this.StrategyList, [(o) => { return o.Portfolio.StrategyRequestDate || '' }], 'desc');
    }

    getFavoritesOnly() {
        this.SearchText = '';
        this.OnlyFavorites = !this.OnlyFavorites;
        if (this.OnlyFavorites) {
            this.StrategyList = this.AvailableStrategyList.filter(x => x.IsFavorite);
        } else {
            this.search();
        }
    }

    navigateToStrategy(strategy?: Strategy) {
        if (strategy) {
            this.router.navigate([ENavigationRoute.Strategy, { id: strategy.Id }]);
        } else {
            this.router.navigate([ENavigationRoute.Strategy]);
        }
    }

    navigateToStrategyDetail(strategy: Strategy) {
        this.router.navigate([ENavigationRoute.StrategyDetail, { id: strategy.Id }]);
    }

    navigateToPurchaseView(strategy: Strategy) {
        this.router.navigate([ENavigationRoute.Order, { id: strategy.Id }]);
    }

    openExportBox() {
        const dialogRef = this.dialog.open(ExportBoxDialog, {
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result) {

                this.documentService.getMeasureOPExport(result.Year, result.Month).subscribe(x => {
                    this.promptFile(x);
                })
            }
        });
    }
}
